export default {
      id: "ico_split-usage",
      viewBox: "0 0 2 12",
      url: __webpack_public_path__ + "img/icons.187741c9.svg#ico_split",
      toString: function () {
        return this.url;
      }
    }